// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","logoFooter":"Logo_logoFooter__1a6Zg"};